module.exports = __webpack_public_path__ + "static/media/receipt.7de7aa43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/receipt.svg
// module id = 1355
// module chunks = 0